<template>
  <div v-if="currentExampleNew" id="example" :class="$mq" :style="{ minHeight: this.$store.getters.fullWindowHeightMinusFooter }">
  <!-- em. minHeight EI TOIMI JOSTAINN SYYSTÄ!!! -->

    <!-- banner -->
    <div id="showcase-banner" class="relative">
      <div id="showcase-bg" :style="{ backgroundImage: 'url(' + currentExampleNew.mainImg + ')' }">
        <!-- kuvan tekijätiedot -->
        <!-- <div class="author-info">{{ currentExampleNew.mainImgAuthor }}</div> -->
        <div v-html="currentExampleNew.mainImgAuthor" class="author-info"></div>
      </div>
      <div id="showcase-info" class="w-full mx-auto">
        <div class="relative flex justify-center align-center h-3 px-6">
          <img :src="currentExampleNew.mainAxo" alt="">
          <h1 class="relative pt-6 txt-bold break-word">{{ this.currentExampleNew.title }}</h1>
        </div>
      </div>
      <!-- navigation -->
      <div class="absolute bg-theme flex py-2 px-3 rounded-3 mt-2 opacity-6 hover-opa-10 color-white noselect" style="top: 0; left: 50%; transform: translateX(-50%);">
        <i @click="navigate('prev')" class="material-icons mr-2">keyboard_arrow_left</i>
        <i @click="navigate('')" class="material-icons">undo</i>
        <i @click="navigate('next')" class="material-icons ml-2">keyboard_arrow_right</i>
      </div>
    </div>

    <!-- other -->
    <div class="showcase wrapper mt-12">
      <!-- main card -->
      <div class="item card" style="grid-column: 1/-1;">
        <div class="mean-content-wrapper" style="max-width: 800px; margin: 0 auto;">

          <div class="content grid">
            <div class="mean-card-main-info">
              <p class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">sijainti: </span>{{ currentExampleNew.locCountry }}, {{ currentExampleNew.locCity }}</p>
              <p class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">valmistunut: </span>{{ currentExampleNew.year }}</p>
              <!-- <p v-if="currentExampleNew.address" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">osoite: </span>{{ currentExampleNew.address }}</p>
              <p v-if="currentExampleNew.by" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">suunnittelijat: </span>{{ currentExampleNew.by }}</p>
              <p v-if="currentExampleNew.size" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">laajuustiedot: </span>{{ currentExampleNew.size }}</p>
              <p v-if="currentExampleNew.tenure" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">hallintamuoto: </span>{{ currentExampleNew.tenure }}</p> -->
              <p v-if="currentExampleNew.address" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">osoite: </span><span v-html="currentExampleNew.address"></span></p>
              <p v-if="currentExampleNew.by" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">suunnittelijat: </span><span v-html="currentExampleNew.by"></span></p>
              <p v-if="currentExampleNew.size" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">laajuustiedot: </span><span v-html="currentExampleNew.size"></span></p>
              <p v-if="currentExampleNew.tenure" class="font-9 px-1 mb-2"><span class="color-grey-l1 font-8 txt-bold">hallintamuoto: </span><span v-html="currentExampleNew.tenure"></span></p>
              <span></span>

              <!-- <p class="px-1 mt-5 mb-2 font-9">{{ currentExampleNew.mainInfo }}</p> -->
              <p v-html="currentExampleNew.mainInfo" class="px-1 mt-5 mb-2 font-9"></p>
            </div>

            <!-- list of links -->
            <div
              @click="listOfLinks = !listOfLinks"
              class="relative w-full flex justify-between align-center px-1 my-3 pointer noselect hover-bg-grey-l3"
            >
              <div class="flex justify-start align-center">
                <span class="txt-bold">Ketteryyden resepti:</span>
              </div>
              <i v-if="listOfLinks" class="material-icons">expand_less</i>
              <i v-else class="material-icons">expand_more</i>
            </div>
            <div v-if="listOfLinks" class="px-1">
              <toolbox :currentItem="currentExampleNew"></toolbox>
            </div>

          </div>

        </div>
      </div>
      <!-- map -->
      <div class="item card" style="grid-column: 1/-1;">
        <div class="content grid" style="height: 45vh; min-height: 280px; max-height: 450px;">
          <!-- <Gmap v-if="currentExampleNew" :lat="this.currentExampleNew.mapLat" :lng="this.currentExampleNew.mapLng"/> -->
          <Gmap v-if="currentExampleNew" :coords="[this.currentExampleNew.mapLat, this.currentExampleNew.mapLng]"/>
        </div>
      </div>

      <!-- galleria -->
      <Gallery>
        <!-- cards -->
        <GitemExample
          v-for="(mean, index) in currentExampleNew.addedMeans"
          :key="index"
          :data="mean"
        ></GitemExample>
      </Gallery>

    </div>

  </div>
</template>

<script>
// import { mapState, mapGetters } from 'vuex'
import Gallery from '@/components/Gallery.vue'
import GitemExample from '@/components/GitemExample.vue'
import Gmap from '@/components/Gmap.vue'
import book from '@/components/book.vue'
import toolbox from '@/components/toolbox.vue'

export default {
  name: 'example',

  components: {
    Gallery,
    GitemExample,
    Gmap,
    book,
    toolbox
  },

  data () {
    return {
      listOfLinks: true
    }
  },

  created () {
    this.$store.dispatch('storeExamples')
  },

  computed: {
    currentExampleNew () {
      return this.$store.state.examples.find(example => {
        return example.slug === this.$route.params.example_id
      })
    }
  },

  methods: {
    navigate (where) {
      let slugs = this.$store.getters.slugsOfExamples
      let thisIndex = slugs.indexOf(this.$route.params.example_id)

      if (where === 'prev') {
        if (thisIndex === 0) {
          thisIndex = slugs.length
        }
        thisIndex = thisIndex - 1
        this.$router.push({ name: 'kohde', params: { example_id: slugs[thisIndex] } })
      } else if (where === 'next') {
        thisIndex = thisIndex + 1
        thisIndex = thisIndex % slugs.length
        this.$router.push({ name: 'kohde', params: { example_id: slugs[thisIndex] } })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="scss">

#showcase-bg {
  position: relative;
  width: 100%;
  height: 75vh;
  min-height: 250px;
  max-height: 750px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  #example.phone & {
    height: 45vh;
  }
  #example.tablet & {
    height: 65vh;
  }
  .author-info {
    position: absolute;
    right: 10px;
    bottom: 7px;
    font-size: 0.75rem;
    color: black;
    text-shadow: 0px 0px 4px rgba(255, 255, 255, 1);
  }
}

#showcase-info {
  max-width: 1100px;
  #example.others & { max-width: 1250px; }
  h1 {
    font-size: 3rem;
    #example.phone & { font-size: 2.2rem; }
    #example.tablet & { font-size: 2.6rem; }
  }
  img {
    position: absolute;
    left: 20px;
    bottom: -35px;
    width: 35vw;
    min-width: 240px;
    max-width: 400px;
  }
}
</style>
